<script setup>
  import {__} from "../../../../assets/javascripts/library";
  import PdfViewer from "../../../../assets/components/PdfViewer.vue";
  import { reactive } from 'vue';

  const props = defineProps({
    newInvoice: {
      type: Object,
      required: true
    },
    costunits: {
      type: Object,
      required: true
    }
  })

  const emit = defineEmits(['submit', 'cancel'])

  const formData = reactive({
    type_internal: props.newInvoice.type_internal || '',
    cost_unit: props.newInvoice.costunit_id || '',
    amount: props.newInvoice.amount_simple || '',
    reason_of_correction: '',
  })

  const submitForm = () => {
    emit('submit', formData)
  }


</script>

<template>
  <form @submit.prevent="submitForm">
    <table>
      <tr>
        <td>{{__('Invoice type', 'mareike')}}:</td>
        <td style="width: 450px;">
          <select v-model="formData.type_internal" class="mareike-select width-full">
            <option value="Travelling">{{__('Travelling', 'mareike')}}</option>
            <option value="Program">{{__('Program', 'mareike')}}</option>
            <option value="Accommodation">{{__('Accommodation', 'mareike')}}</option>
            <option value="Catering">{{__('Catering', 'mareike')}}</option>
            <option value="Other">{{__('Other', 'mareike')}}</option>
          </select>
        </td>
      </tr>

      <tr>
        <td>{{__('Cost unit', 'mareike')}}:</td>
        <td>
          <select v-model="formData.cost_unit" class="mareike-select width-full">
            <option v-for="costunit in props.costunits" :value="costunit.id">{{costunit.cost_unit_name}}</option>
          </select>
        </td>
      </tr>

      <tr>
        <td>{{__('Total amount', 'mareike')}}:</td>
        <td>
          <input type="text" v-model="formData.amount" class="mareike-text width-almost-full" />
          Euro
        </td>
      </tr>

      <tr>
        <td>{{__('Reason of correction', 'mareike')}}:</td>
        <td>
          <input type="text" v-model="formData.reason_of_correction" class="mareike-text width-full" />
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <input type="checkbox" v-model="formData.duplicate" id="mareike_correct_invoice_duplicate" />
          <label for="mareike_correct_invoice_duplicate">{{__('Duplicate invoice', 'mareike')}}</label>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <input type="submit" :value="__('Save and accept', 'mareike')" class="button mareike-accept-button" />
        </td>
      </tr>
    </table>
  </form>
  <br /><br />

  <PdfViewer :url="props.newInvoice.receipt_url" v-if="props.newInvoice.receipt_url !== ''" :docPath="props.newInvoice.document_filename" />
</template>

<style>
  .width-full {
    width: 100%;
  }

  .width-almost-full {
    width: calc(100% - 75px);
  }

  .width-half-full {
    width: 50%;
  }

  .width-small {
    width: 100px;
  }
</style>